import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import ViewProfile from "./ViewProfile/index";
import EditProfile from "./EditProfile/index";
import ChangePassword from "./ChangePassword/index";
import close from "assets/images/close.svg";

import styles from "./Profile.module.scss";

const Profile = ({ isOpen, toggle }) => {
  let [activeStep, setActiveStep] = useState(0);

  let [user, setUser] = useState();

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, []);

  const getTitle = () => {
    if (activeStep === 0) {
      return "MY PROFILE";
    } else if (activeStep === 1) {
      return "EDIT PROFILE";
    } else if (activeStep == 2) {
      return "CHANGE PASSWORD";
    }
  };

  const getTabContent = () => {
    if (activeStep === 0) {
      return (
        <ViewProfile
          data={user}
          editProfileTab={editProfileTab}
          changePasswordTab={changePasswordTab}
        />
      );
    } else if (activeStep === 1) {
      return <EditProfile profileTab={profieTab} data={user} />;
    } else if (activeStep === 2) {
      return <ChangePassword toggle={toggle} />;
    }
  };

  const profieTab = () => {
    setActiveStep(0);
  };

  const editProfileTab = () => {
    setActiveStep(1);
  };

  const changePasswordTab = () => {
    setActiveStep(2);
  };

  const profileToggle = () => {
    toggle();
    setTimeout(() => {
      setActiveStep(0);
    }, 1000);
  };

  return (
    <Modal isOpen={isOpen} toggle={profileToggle}>
      <ModalBody>
        <div className={styles.profile_modal}>
          <div className={styles.close_icon} onClick={() => profileToggle()}>
            <img src={close} />
          </div>
          <div className={styles.profile_title}>
            <b>{getTitle()}</b>
          </div>
          <div className={styles.profile_content}>{getTabContent()}</div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Profile;
